import React, { FC } from 'react';

import { SelectProps } from 'antd';
import Select from 'antd/lib/select';
import { colorConstants } from 'config/colorConstants';
import Loader from '../Loader';
import ErrorBox from '../ErrorBox/ErrorBox';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

type OfferDropdownItem = {
    offer: string;
    uplift?: { value: string | number; isPositive: boolean };
    mpic?: { value: string | number; isPositive: boolean };
    incrementalSales?: { value: string | number; isPositive: boolean };
};

interface Props extends SelectProps {
    data: OfferDropdownItem[];
}
const { Option } = Select;

const OfferDropdown: FC<Props> = ({ data, ...restProps }) => {
    const { loading, ...selectProps } = restProps;
    return (
        <Select
            {...selectProps}
            placement="bottomRight"
            dropdownStyle={{ minWidth: '300px' }}
            notFoundContent={
                loading ? (
                    <div className="p-3">
                        <Loader />
                    </div>
                ) : (
                    <ErrorBox msg="No Data" />
                )
            }
        >
            {loading ? (
                <Option key="loading" disabled style={{ textAlign: 'center' }}>
                    <Loader />
                </Option>
            ) : (
                data?.map((item) => {
                    return (
                        <Option item={item} value={item?.offer} key={item?.offer}>
                            <div className="text-xs">{item.offer}</div>
                            <div className="flex gap-4 mt-1">
                                {item?.uplift && (
                                    <div className="flex gap-1 items-center">
                                        <span className="text-fontGreyAlt font-xxs font-xsa">Uplift:</span>
                                        {item?.uplift?.isPositive ? (
                                            <ArrowUpOutlined style={{ color: colorConstants.limeGreen }} />
                                        ) : (
                                            <ArrowDownOutlined style={{ color: colorConstants.red }} />
                                        )}
                                        <span
                                            style={{
                                                color: item?.uplift?.isPositive
                                                    ? colorConstants.limeGreen
                                                    : colorConstants.red,
                                            }}
                                        >
                                            {item.uplift.value}
                                        </span>
                                    </div>
                                )}
                                {item?.mpic && (
                                    <div className="flex gap-1 items-center">
                                        <span className="text-fontGreyAlt font-xxs">MPIC:</span>
                                        {item?.mpic?.isPositive ? (
                                            <ArrowUpOutlined style={{ color: colorConstants.limeGreen }} />
                                        ) : (
                                            <ArrowDownOutlined style={{ color: colorConstants.red }} />
                                        )}
                                        <span
                                            style={{
                                                color: item?.mpic?.isPositive
                                                    ? colorConstants.limeGreen
                                                    : colorConstants.red,
                                            }}
                                        >
                                            {item.mpic.value}
                                        </span>
                                    </div>
                                )}
                                {item?.incrementalSales && (
                                    <div className="flex gap-1 items-center">
                                        <span className="text-fontGreyAlt font-xxs">Inc Net Sales:</span>
                                        {item?.incrementalSales?.isPositive ? (
                                            <ArrowUpOutlined style={{ color: colorConstants.limeGreen }} />
                                        ) : (
                                            <ArrowDownOutlined style={{ color: colorConstants.red }} />
                                        )}
                                        <span
                                            style={{
                                                color: item?.incrementalSales?.isPositive
                                                    ? colorConstants.limeGreen
                                                    : colorConstants.red,
                                            }}
                                        >
                                            {item.incrementalSales.value}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </Option>
                    );
                })
            )}
        </Select>
    );
};

export default OfferDropdown;
